module.exports = __webpack_public_path__ + "img/UHF-DVS-25.8c313196.png";